<template>

    <section>
        <div :style="{borderColor: $store.getters.clientStyle.primary}"
          class="global-question-card container global-question-card-padding"
          @mouseover="comment.questionIsFocussed=true"
          @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">

          <!-- Component for question title, description, number and required indicator -->
          <question-header />

          <!-- Specific markup for this question type -->
          <div class="columns global-answer-padding">

            <div class="column is-four-fifths">
              <b-input v-model="questionData.answer" class="text-input" placeholder="Type hier een antwoord..." type="textarea" @blur="saveAnswer">
              </b-input>
            </div>

            <!-- button area (right side of question card) -->
            <div class="column is-one-fifth">
              <question-options />
            </div>
          </div>
        </div>

        <!-- Comment component to be redered when comments are allowed for this question -->
        <comment-box ref="commentBox" v-if="questionData.comment=='1'" />
         <!-- Comment component to be redered when comments are allowed for this question -->
         <div v-for="(upload, index) in uploads" class="commentPadding">
          <upload-box :key="index" ref="uploadBox" :upload="upload" :index="index" />

         </div>
    </section>

        <!-- <v-btn type="primary" @click="openDialog">Bijlage uploaden</v-btn>
        <input style="display: none" type="file" @change="onFileChange" ref="fileinput" :multiple="multiple">
        <p v-if="multiple && item.id === id.$oid" v-for="item in uploaded">{{ item.file }}</p>
        <span v-if="!multiple && firstElement(uploaded).id === question_id.$oid">{{ firstElement(uploaded).file }}</span> -->
</template>

<script>
import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'
import UploadBox from './UploadBox'

export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox,
    'upload-box': UploadBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      radio: 'default',
      answer: null,
      uploads: [],
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      }
    }
  },
  methods: {
    saveAnswer () {
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    }
  },
  created () {
    //fix v-model error of getting an array instead of string
    if (this.questionData.answer instanceof Array) {
      this.questionData.answer = null
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/AttachmentQuestion.vue